<template>
  <div>
    <!-- Filter Start -->
    <div class="innerBox mb-4">
      <div class="row">
        <div class="col-md-10">
          <input
            class="form-control filterInput"
            type="search"
            placeholder="Masukkan Nomor Nopol"
            aria-label="Search"
            style="display: flex; font: normal normal normal 16px/25px Poppins"
            v-model="filter.search"
          />
        </div>
        <div
          class="col-md-2 text-right"
          style="display: flex; justify-content: flex-end"
        >
          <button
            class="btn"
            type="button"
            style="
              background-color: #1b698e;
              color: white;
              padding: 0 50px;
              height: 100%;
              font-weight: bold;
              display: flex;
              align-items: center;
              font: normal normal 600 14px/21px Poppins;
            "
            @click="vue_universal_table.update++"
          >
            CARI
          </button>
        </div>
      </div>
    </div>
    <!-- Filter End -->

    <!-- Body Start -->
    <div class="innerBox">
      <!-- Title & Option Buttons Start -->
      <div class="mb-4 row">
        <div
          class="col-md-5 text-left"
          style="display: flex; flex-direction: column-reverse"
        >
          <h3 class="mb-0" style="font: normal normal normal 16px/25px Poppins">
            Truck Checking
          </h3>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-6">
          <div class="d-flex">
            <div
              class="col-3"
              style="
                display: flex;
                align-items: center;
                font: normal normal normal 12px/18px Poppins;
              "
            >
              <span style="font: normal normal normal 12px/18px Poppins"
                >Filter Tanggal</span
              >
            </div>
            <div
              class="col-9"
              style="font: normal normal normal 12px/18px Poppins"
            >
              <div class="d-flex justify-content-between">
                <flat-pickr
                :config="rangePickr"
                placeholder="Select Date"
                v-model="selected.date"
                style="font: normal normal normal 12px/18px Poppins"
              ></flat-pickr>
              <button
                class="btn ml-3"
                type="button"
                style="
                  background-color: #f36f21;
                  color: white;
                  width: 100%;
                  font-weight: bold;
                  margin: 0;
                "
                @click="exportExcel"
              >
                Export Excel
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Title & Option Buttons End -->

      <!-- Table Start -->
      <vue-universal-table
        api_url="/api/validation/pengecekan-truk/list"
        :filter="filter"
        :update="vue_universal_table.update"
        :fields="vue_universal_table.fields"
        :buttons="vue_universal_table.buttons"
        :infinite_scroll="true"
        sort_order="DESC"
        sort_by="created_at"
        style="font: normal normal normal 12px/18px Poppins"
        style_button="true"
        @onLihatDetail="openPengecekanDetails"
      ></vue-universal-table>
      <!-- Table End -->
    </div>
    <!-- Body End -->
  </div>
</template>

<script>
import moment from "moment";
import debounce from "debounce";
import qs from 'qs';
export default {
  metaInfo: {
    title: "Pengecekan Truck",
  },
  data() {
    let startDate = moment().startOf("month").format("YYYY-MM-DD");
    let currentDate = moment().format("YYYY-MM-DD");
    return {
      rangePickr: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d-m-Y",
        altInputClass: "form-control input elegant-flatpickr",
      },
      selected: {
        date: `${startDate} to ${currentDate}`,
      },
      filter: {
        start: startDate,
        end: currentDate,
        search: null,
      },
      vue_universal_table: {
        fields: [
          { title: "Nama Driver", variable: "driver", disable_sort: true },
          { title: "Nopol", variable: "nopol", disable_sort: true },
          { title: "Nama Security", variable: "officer_name", disable_sort: true },
          { title: "Points", variable: "all_point", disable_sort: true },
          { title: "Status", variable: "status", disable_sort: true },
          { title: "Jenis Truck", variable: "jenis_truck", disable_sort: true },
          { title: "Tanggal Checking", variable: "created_at", disable_sort: true },
        ],
        buttons: [{ title: "lihatDetail", class: "btn btn-outline-primary" }],
        update: 0,
      },
    };
  },
  methods: {
    openPengecekanDetails(data) {
      this.$store.state.pengecekanTruckData = data;
      this.$router.push({ path: "/dashboard/pengecekan-truck/detail" });
    },
    exportExcel() {
        if (this.filter.search === '') delete this.filter.search;
        
        this.$http.get(`/api/validation/pengecekan-truk/export-excel?${qs.stringify(this.filter, {skipNulls:true, arrayFormat: 'comma'})}`, { responseType: 'blob' })
        .then((response) => {
                  // create file link in browser's memory
            const href = URL.createObjectURL(response.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', `activity-history-${moment().format('YYYYMMDDHHmmss')}.xlsx`); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        });
    },
    filterData: debounce(function () {
      this.vue_universal_table.update++;
    }, 2000),
  },
  watch: {
    "selected.date"() {
      let split = this.selected.date.split(" to ");
      this.filter.start = split[0];
      this.filter.end = split.length > 1 ? split[1] : split[0];
    },
    filter: {
      deep: true,
      handler: "filterData",
    },
  },
};
</script>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.tableTitle {
  text-align: center;
}

/* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.table td,
.table th {
  text-align: center;
}
</style>
